<div class="modal fade" [ngClass]="{'show': isVisible}" id="modalSidebar" tabindex="-1" role="dialog" aria-labelledby="modalSidebarLabel">

        <div class="modal-dialog" role="document" [ngClass]="{'modal-dialog-show': isVisible}" >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalSidebarLabel">{{title}}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <router-outlet name="aside"></router-outlet>
            </div>
            <div class="modal-footer">
            </div>
          </div>
        </div>
      </div>